import type { FC } from "react";
import { useGoalsRight } from "web_myplann/Api/Rights/RightsProvider";
import { DashboardDetailPage } from "web_myplann/Dashboard/Pages/DashboardDetailPage";
import { DashboardDetailV2Page } from "web_myplann/Dashboard/Pages/DashboardDetailV2Page";
import { DashboardVariantContext } from "web_myplann/Dashboard/State/dashboardVariantContext";

export const DashboardDetailPageResolver: FC = () => {
	const hasGoalsRight = useGoalsRight();

	return (
		<DashboardVariantContext.Provider value={hasGoalsRight ? "v2" : "v1"}>
			{hasGoalsRight ? <DashboardDetailV2Page /> : <DashboardDetailPage />}
		</DashboardVariantContext.Provider>
	);
};
